import React from 'react'
import Portfolio from '../../componets/Portfolio'

const Section1 = () => {
  return (
    <div className="w-full h-[30vh] xl:h-[65vh] Section1">
      <Portfolio
        bgImage={"assets/computer-banner-web-development.jpg"}
        objectPosition="object-center"
        customer={false}
        altText="Computer Background Image"
      />
    </div>
  )
}

export default Section1
